import { useRef, useState, useEffect } from "react";
import { getAllStates, getAllCities, getCityById } from "@/services/addresses";
import { DEFAULT_ID } from "./utils";

export const useStates = (disabled = false) => {
  const [loading, setLoading] = useState(false);
  const [states, setStates] = useState([]);
  const [shortName, setShortNameStates] = useState({});

  useEffect(() => {
    if (disabled) {
      return;
    }

    setLoading(true);

    getAllStates()
      .then(response => {
        const _states = response?.items || [];
        const _shortNameStates = {};

        for (const state of _states) {
          _shortNameStates[state.id] = {
            shortName: state.shortName,
            name: state.name,
          };
        }

        setStates(_states);
        setShortNameStates(_shortNameStates);
      })
      .finally(() => {
        setLoading(false);
      });
  }, [disabled]);

  return { loading, states, shortName };
};

export const useCities = (searchText, stateId, cityId = null, disabled = false) => {
  const timeoutRef = useRef(null);

  const [search, setSearch] = useState(searchText);
  const [loading, setLoading] = useState(false);
  const [cities, setCities] = useState([]);

  useEffect(() => {
    if (disabled || searchText === search) {
      return;
    }

    if (timeoutRef.current !== null) {
      clearTimeout(timeoutRef.current);
    }

    timeoutRef.current = setTimeout(() => {
      setSearch(searchText);
      timeoutRef.current = null;
    }, 500);
  }, [disabled, searchText, search]);

  useEffect(() => {
    if (disabled) {
      return;
    }

    setLoading(true);

    getAllCities({ page: 0, pageSize: 10, stateId, filterText: search })
      .then(async response => {
        const items = response?.items || [];
        const needsToIncludeCity = cityId !== undefined && cityId !== null && cityId !== DEFAULT_ID;
        const needsToFetchCity = needsToIncludeCity && items.every(city => city.id !== cityId);

        if (needsToFetchCity) {
          try {
            const city = await getCityById(cityId);
            if (city) {
              items.push(city);
            }
          } catch (error) {
            console.log(error);
          }
        }

        setCities(items);
      })
      .then(() => {
        setLoading(false);
      });
  }, [disabled, stateId, cityId, search]);

  return { loading, cities };
};
